<template>
  <div class="app">
    <v-card>
      <!-- <pre>{{ dataset }}</pre> -->
      <!-- <v-btn small color="success" @click="check">Check</v-btn> -->
      <v-container fluid grid-list-lg>
        <div v-bind="text" class="font-weight-thin title">
          Ques: {{ text.question }}
        </div>
        <v-layout row>
          <v-flex xs12>
            <VueApexCharts
              type="boxPlot"
              height="350"
              :options="chartOptions"
              :series="series"
            ></VueApexCharts>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import VueApexCharts from "vue-apexcharts";

  export default {
    props: ["dataset"],
    components: {
      VueApexCharts,
    },
    data: () => ({
      text: {
        question: null,
      },
      series: [
        {
          type: "boxPlot",
          data: [
            {
              x: "",
              y: [],
            },
          ],
        },
      ],
      chartOptions: {
        chart: {
          type: "boxPlot",
          height: 350,
        },
        title: {
          text: "Slider BoxPlot Chart",
          align: "left",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
          boxPlot: {
            colors: {
              upper: "#5C4742",
              lower: "#A5978B",
            },
          },
        },
      },
    }),
    watch: {
      dataset: function () {
        this.initialize();
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        // console.log(this.dataset.graphData.series);
        this.series[0].data[0].y = this.dataset.graphData.series;
        this.text.question = this.dataset.queSet.question;
      },
      check() {
        // console.log(this.dataset);
        // console.log(this.series);
      },
    },
  };
</script>
